var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook",
    "data-name": "Icon awesome-facebook",
    d: "M32.563,16.66a16,16,0,1,0-18.5,15.9V21.313H10V16.66h4.065V13.113c0-4.034,2.387-6.262,6.043-6.262a24.479,24.479,0,0,1,3.582.314v3.959H21.67a2.32,2.32,0,0,0-2.607,2.514V16.66H23.5l-.71,4.653H19.063V32.563A16.074,16.074,0,0,0,32.563,16.66Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#92a7ba",
    opacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1b6a76bd34e1ece66fbbf0480de8a3a8.svg";
export { ForwardRef as ReactComponent };